import { AdviceLedger } from '../components/AdviceLedger.tsx';

/** The advice record's own route (T-058) — behind auth like `/tracker`,
 * `/compare` and `/leagues`: a signed-in manager sees their own honesty
 * ledger, a signed-out visitor gets the landing page instead, same as those
 * three routes. */
export function LedgerRoute() {
  return <AdviceLedger />;
}
